import { render, staticRenderFns } from "./FarmerMenu.vue?vue&type=template&id=3dc2c0f8&scoped=true&"
import script from "./FarmerMenu.vue?vue&type=script&lang=js&"
export * from "./FarmerMenu.vue?vue&type=script&lang=js&"
import style0 from "./FarmerMenu.vue?vue&type=style&index=0&id=3dc2c0f8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc2c0f8",
  null
  
)

export default component.exports